import React from "react";
import { RequestStatus } from "@/types/request";
import { useBulkUpdateTasks } from "../hooks/tasks.hooks";
import { RequestStatusSelect } from "./RequestStatusSelect";
import AssignStaffModal from "./modals/AssignStaffModal";
import { AssignedStaffCell } from "@/components/common/AssignedStaffCell";
import { Button } from "@/components/ui/button";
import { Trash } from "lucide-react";
import { useBulkDeleteRequests } from "../hooks/useRequests";

interface RequestBulkActionsProps {
  selectedItems: string[];
  selectedTasks?: string[];
}

export const RequestBulkActions: React.FC<RequestBulkActionsProps> = ({
  selectedItems,
  selectedTasks,
}) => {
  const updateTaskMutation = useBulkUpdateTasks();
  const deleteMutation = useBulkDeleteRequests();

  const [open, setOpen] = React.useState(false);

  return (
    <div className="flex items-center gap-[10px]">
      <RequestStatusSelect
        currentStatus={"NEW_TASK"}
        hideCurrentStatus
        requestId={""}
        onStatusChange={(_, status) => {
          if (selectedTasks) {
            updateTaskMutation.mutateAsync({
              data: {
                status: status as RequestStatus,
                taskIds: selectedTasks,
              },
            });
          }
        }}
      />

      <AssignStaffModal
        taskId={""}
        open={open}
        onOpenChange={setOpen}
        assignedStaffId={""}
        externalChangeHandler={({ staffId, teamStaffId }) => {
          if (selectedTasks) {
            const data = staffId
              ? { staffId, taskIds: selectedTasks }
              : { teamStaffId, taskIds: selectedTasks };

            updateTaskMutation.mutateAsync({
              data,
            });
          }
        }}
        trigger={
          <div
            className="cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              setOpen(true);
            }}
          >
            <AssignedStaffCell
              taskId={undefined}
              teamId={undefined}
              staffId={undefined}
              externalUse
              className="border-black border-2 font-normal [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex w-fit items-center justify-center gap-2 rounded-md bg-transparent px-3 py-3 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-12 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4"
            />
          </div>
        }
      />

      <Button
        variant={"outline"}
        onClick={() => {
          if (selectedItems.length > 0) {
            deleteMutation.mutate(selectedItems);
          }
        }}
      >
        <Trash />
        Delete
      </Button>
    </div>
  );
};
